import React from 'react'
import css from './NoJobsMessage.module.css'

const NoJobsMessage = (
  <p className={css.noJobsMessage}>
    There are no job openings right now, but we’re always on the lookout for amazing new people!
    <br />
    If you think this could be the team for you, email us at&nbsp;
    <a href="mailto:jobs@gousto.co.uk">
      jobs@gousto.co.uk
    </a>
    &nbsp;with your cover letter and CV.
  </p>
)

export { NoJobsMessage }
